import { render } from "./add.vue?vue&type=template&id=7c18bb42&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=7c18bb42&style=scss&scoped=true&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c18bb42"],['__file',"src/views/branch/staff/add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c18bb42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c18bb42', __exports__)) {
    console.log('reload')
    api.reload('7c18bb42', __exports__)
  }
  
  module.hot.accept("./add.vue?vue&type=template&id=7c18bb42&scoped=true", () => {
    console.log('re-render')
    api.rerender('7c18bb42', render)
  })

}


export default __exports__